export enum BillingProviderEnumDTO {
    Vindi = "Vindi",
    Iugu = "Iugu",
    Asaas = "Asaas",
    DomPagamentos = "DomPagamentos"
}
